import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row, Col, Table, Badge, Button, Form, Spinner } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getDanhSachCongViecTongHopAction, toggleQuanTamAction } from '../../store/reducers/quanLyCongViecTongHop';
import { teamGetAllAction } from '../../store/reducers/team';
import { nhanVienGetAllAction } from '../../store/reducers/nhanVien';
import { URI_INTERNAL } from '../../utils/pathLocations';

const MODULE_OPTIONS = [
  { value: 1, label: 'Phát triển phần mềm' },
  { value: 2, label: 'Xử lý yêu cầu' },
  { value: 3, label: 'Hỗ trợ phần mềm' },
  { value: 4, label: 'Nhiệm vụ khác' }
];

const QuanLyCongViecTongHop = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data, loading, totalRecords, pageIndex, pageSize, error } = useSelector((state) => state.quanLyCongViecTongHop);
  const teamList = useSelector((state) => state.team.list);
  const nhanVienList = useSelector((state) => state.nhanVien?.list);

  useEffect(() => {
    dispatch(teamGetAllAction());
    dispatch(nhanVienGetAllAction());
  }, [dispatch]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialPage = parseInt(searchParams.get('page')) || 1;
  const initialSize = parseInt(searchParams.get('size')) || 20;

  const [filter, setFilter] = useState({
    Keyword: searchParams.get('keyword') || '',
    ModuleType: searchParams.get('moduleType') || '',
    TeamId: searchParams.get('teamId') || '',
    AssigneeId: searchParams.get('assigneeId') || '',
    StatusName: searchParams.get('statusName') || '',
    InterestStatus: searchParams.get('interestStatus') || '0',
    PageIndex: initialPage,
    PageSize: initialSize
  });

  const [keywordInput, setKeywordInput] = useState(searchParams.get('keyword') || '');

  useEffect(() => {
    fetchData(filter);

    const params = new URLSearchParams();
    if (filter.PageIndex) params.set('page', filter.PageIndex);
    if (filter.PageSize) params.set('size', filter.PageSize);
    if (filter.Keyword) params.set('keyword', filter.Keyword);
    if (filter.ModuleType) params.set('moduleType', filter.ModuleType);
    if (filter.StatusName) params.set('statusName', filter.StatusName);
    if (filter.TeamId) params.set('teamId', filter.TeamId);
    if (filter.AssigneeId) params.set('assigneeId', filter.AssigneeId);
    if (filter.InterestStatus && filter.InterestStatus !== '0') params.set('interestStatus', filter.InterestStatus);

    const newSearch = params.toString();
    const currentSearch = location.search.replace(/^\?/, '');
    if (newSearch !== currentSearch) {
      history.replace({ pathname: location.pathname, search: newSearch });
    }
  }, [filter, location.pathname, location.search, history]);

  const fetchData = (currentFilter) => {
    dispatch(getDanhSachCongViecTongHopAction(currentFilter));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setFilter(prev => {
        if (prev.Keyword !== keywordInput) {
          return { ...prev, Keyword: keywordInput, PageIndex: 1 };
        }
        return prev;
      });
    }, 500); // Debounce 500ms
    return () => clearTimeout(timer);
  }, [keywordInput]);

  const handleFilterChange = (key, value) => {
    setFilter(prev => ({ ...prev, [key]: value, PageIndex: 1 }));
  };

  const handleToggleQuanTam = async (item) => {
    const res = await dispatch(toggleQuanTamAction({ workItemId: item.id || item.Id, moduleType: item.moduleType || item.ModuleType }));
    if (!res.error) {
      toast.success('Đã cập nhật trạng thái Quan tâm');
      fetchData(filter); // refetch list
    } else {
      toast.error('Có lỗi xảy ra');
    }
  };

  const handleNavigate = (item) => {
    const mType = item.moduleType || item.ModuleType;
    const id = item.id || item.Id;
    const returnUrl = `&returnUrl=${encodeURIComponent(location.pathname + location.search)}`;

    switch (mType) {
      case 1:
        history.push(`${URI_INTERNAL.PROJECT_DETAIL_PATH}?id=${id}${returnUrl}`);
        break;
      case 2:
        history.push(`${URI_INTERNAL.YEUCAU_EDIT_PATH}?id=${id}${returnUrl}`);
        break;
      case 3:
        history.push(`${URI_INTERNAL.HOTRO_EDIT_PATH}?id=${id}${returnUrl}`);
        break;
      case 4:
        history.push(`${URI_INTERNAL.NHIEMVUKHAC_EDIT_PATH}?id=${id}${returnUrl}`);
        break;
      default:
        break;
    }
  };

  const renderModuleBadge = (mType) => {
    switch (mType) {
      case 1: return <Badge variant="primary">Phát triển phần mềm</Badge>;
      case 2: return <Badge variant="warning">Xử lý yêu cầu</Badge>;
      case 3: return <Badge variant="success">Hỗ trợ phần mềm</Badge>;
      case 4: return <Badge variant="danger">Nhiệm vụ khác</Badge>;
      default: return null;
    }
  };

  const getStatusLabel = (statusString) => {
    if (!statusString) return '';
    const s = String(statusString).toLowerCase();
    switch (s) {
      case 'chuabatdau': return 'Chưa bắt đầu';
      case 'dangthuchien': return 'Đang thực hiện';
      case 'dangtest': return 'Đang test';
      case 'chophanhoi': return 'Chờ phản hồi';
      case 'chonangcap': return 'Chờ nâng cấp';
      case 'hoanthanh': return 'Hoàn thành';
      default: return statusString;
    }
  };

  return (
    <div className="container-fluid" style={{ marginTop: 16 }}>
      <Row className="mb-3">
        <Col lg={12}>
          <Card>
            <Card.Header>
              <h3 className="card-title">Tất cả công việc</h3>
            </Card.Header>
            <Card.Body>
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Tìm kiếm</Form.Label>
                    <div className="d-flex">
                      <Form.Control
                        type="text"
                        placeholder="Từ khoá..."
                        value={keywordInput}
                        onChange={(e) => setKeywordInput(e.target.value)}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col md="auto">
                  <Form.Group>
                    <Form.Label>Module</Form.Label>
                    <Form.Control as="select" value={filter.ModuleType} onChange={(e) => handleFilterChange('ModuleType', e.target.value)}>
                      <option value="">Tất cả</option>
                      {MODULE_OPTIONS.map(m => (
                        <option key={m.value} value={m.value}>{m.label}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md="auto">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Control as="select" value={filter.StatusName} onChange={(e) => handleFilterChange('StatusName', e.target.value)}>
                      <option value="">Tất cả</option>
                      <option value="chuabatdau">Chưa bắt đầu</option>
                      <option value="dangthuchien">Đang thực hiện</option>
                      <option value="dangtest">Đang test</option>
                      <option value="chophanhoi">Chờ phản hồi</option>
                      <option value="chonangcap">Chờ nâng cấp</option>
                      <option value="hoanthanh">Hoàn thành</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md="auto">
                  <Form.Group>
                    <Form.Label>Nhóm</Form.Label>
                    <Form.Control as="select" value={filter.TeamId} onChange={(e) => handleFilterChange('TeamId', e.target.value)}>
                      <option value="">Tất cả</option>
                      {teamList && teamList.map(t => (
                        <option key={t.id || t.Id} value={t.id || t.Id}>{t.name || t.Name}</option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md="auto">
                  <Form.Group>
                    <Form.Label>Người thực hiện</Form.Label>
                    <Form.Control as="select" value={filter.AssigneeId} onChange={(e) => handleFilterChange('AssigneeId', e.target.value)}>
                      <option value="">Tất cả</option>
                      {nhanVienList && nhanVienList.map(nv => {
                        const uid = nv.nguoiDungId || nv.NguoiDungId;
                        if (!uid) return null;
                        const name = nv.hoTen || nv.HoTen || (nv.nguoiDung && nv.nguoiDung.hoTen) || nv.tenNhanVien || "Không tên";
                        return <option key={uid} value={uid}>{name}</option>
                      })}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md="auto">
                  <Form.Group>
                    <Form.Label>Quan tâm</Form.Label>
                    <Form.Control as="select" value={filter.InterestStatus} onChange={(e) => handleFilterChange('InterestStatus', e.target.value)}>
                      <option value="0">Tất cả</option>
                      <option value="1">Đang quan tâm</option>
                      <option value="2">Không quan tâm</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              {loading ? (
                <div className="text-center p-5"><Spinner animation="border" /></div>
              ) : (
                <div className="table-responsive">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th width="40">⭐</th>
                        <th>Tên công việc/Nội dung</th>
                        <th>Module</th>
                        <th>Trạng thái</th>
                        <th>Ngày tạo</th>
                        <th>Hạn xử lý</th>
                        <th>Nhóm</th>
                        <th>Người thực hiện</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data && data.length > 0 ? data.map((item, idx) => {
                        const mType = item.moduleType || item.ModuleType;
                        const isInterested = item.isInterested || item.IsInterested;
                        return (
                          <tr key={idx} className={isInterested ? 'quanly-row-quantam' : ''}>
                            <td className="text-center" style={{ cursor: 'pointer' }} onClick={() => handleToggleQuanTam(item)}>
                              {isInterested ? '⭐' : '☆'}
                            </td>
                            <td>
                              <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleNavigate(item)}>
                                {item.title || item.Title}
                              </span>
                            </td>
                            <td>{renderModuleBadge(mType)}</td>
                            <td>{getStatusLabel(item.statusName || item.StatusName)}</td>
                            <td>{(item.createdDate || item.CreatedDate) ? new Date(item.createdDate || item.CreatedDate).toLocaleDateString('vi-VN') : ''}</td>
                            <td>{item.dueDate || item.DueDate ? new Date(item.dueDate || item.DueDate).toLocaleDateString('vi-VN') : ''}</td>
                            <td>{item.teamName || item.TeamName}</td>
                            <td>{item.assigneeName || item.AssigneeName}</td>
                          </tr>
                        )
                      }) : (
                        <tr><td colSpan="8" className="text-center">Không có dữ liệu</td></tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
              {totalRecords > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="d-flex align-items-center">
                    <span className="mr-2 font-weight-bold">Hiển thị :</span>
                    <Form.Control
                      as="select"
                      value={filter.PageSize}
                      onChange={(e) => setFilter(prev => ({ ...prev, PageSize: Number(e.target.value), PageIndex: 1 }))}
                      style={{ width: '80px' }}
                    >
                      <option value={5}>5</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </Form.Control>
                  </div>
                  <div>
                    <Pagination
                      itemClass="page-item"
                      linkClass="page-link"
                      innerClass="pagination pagination-sm no-margin"
                      activePage={filter.PageIndex}
                      itemsCountPerPage={filter.PageSize}
                      totalItemsCount={totalRecords}
                      pageRangeDisplayed={5}
                      onChange={(pageNumber) => setFilter(prev => ({ ...prev, PageIndex: pageNumber }))}
                    />
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default QuanLyCongViecTongHop;
